import styled, { CSSProp } from 'styled-components'

export const DropDownCountryNameUi = styled.span<{
  styles?: CSSProp
}>`
  margin-right: 0.5em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ styles }) => styles}
`
